window.$script = require("scriptjs");

var event = document.createEvent('Event');

// Define the event name.
event.initEvent('scriptjs-ready', true, true);

// Dispatch the event.
document.dispatchEvent(event);